import { routes } from "../../routes";
import { HeaderWithMenu } from "../../shared/components/header-with-menu";
import { useStation } from "../../shared/hooks/use-station";
import { useUnit } from "../hooks/use-unit";

export const UnitHeader: React.FC = () => {
  const unit = useUnit();
  const station = useStation(unit.stationSlug);
  // Units are booked via QR codes on the respective unit.
  // Therefore, the starting point for a new booking should be the home page with the QR code scanner.
  const homeRoute = routes.home;

  return (
    <HeaderWithMenu
      title={station.name}
      homePath={homeRoute}
      menuItems={[{ name: "Neue Buchung", path: homeRoute }]}
    />
  );
};
